export const WIZARD_DEFINITION = {
  identifier: 'registration-terminal-wizard-configuration',
  defaultWizardFlowStepIdentifier: 'registration-terminal-wizard-configuration',
  wizardFlowMetadata: [
    {
      flowIdentifier: 'registration-terminal-visitor-leave',
      flowDefinition: {
        title: 'Besucher abmelden',
        key: 'registration-terminal-visitor-leave',
        rootStyles: 'terminal-layout',
        inactivityDescriptionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.description',
        inactivityActionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.action',
        steps: [
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-leave-confirmation.title',
            key: 'visitor-leave-confirmation',
            controller: 'process-selection-controller',
            contentIdentifier: 'dashboard-process-selection',
            dashboardConfiguration: {
              selectOptions: [
                {
                  titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.visitor-leave-confirmation.confirm-leave',
                  titleIconCss: 'fa-thin fa-arrow-right-from-bracket',
                  actionType: 'PROCESS_STEP',
                  processStepKey: 'visitor-leave-send-data-to-backend'
                }
              ]
            }
          },
          {
            title: null,
            key: 'visitor-leave-send-data-to-backend',
            controller: 'visitor-leave-send-data-to-backend-controller',
            contentIdentifier: null
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-leave-summary.title',
            key: 'visitor-leave-summary',
            controller: 'visitor-leave-summary-controller',
            contentIdentifier: 'dashboard-visitor-leave-summary'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-leave-failed.title',
            key: 'visitor-leave-failed',
            controller: 'visitor-leave-failed-controller',
            contentIdentifier: 'dashboard-visitor-leave-failed'
          }
        ]
      }
    },
    {
      flowIdentifier: 'registration-terminal-wizard-configuration',
      flowDefinition: {
        title: 'Anmeldeterminal',
        key: 'registration-terminal-wizard-configuration',
        rootStyles: 'terminal-layout',
        inactivityDescriptionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.description',
        inactivityActionDictionarykey: 'tmc-yard.widgets.registration-terminal.inactivity.action',
        steps: [
          {
            title: null,
            key: 'load-terminal-configuration',
            controller: 'terminal-configuration-controller',
            contentIdentifier: null,
            dashboardConfiguration: {
              terminalIdentifier: 'default'
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.language-selection.title',
            key: 'language-selection',
            controller: 'language-selection-controller',
            contentIdentifier: 'dashboard-language-selection'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.title',
            key: 'registration-type-selection',
            controller: 'process-selection-controller',
            contentIdentifier: 'dashboard-process-selection',
            dashboardConfiguration: {
              selectOptions: [
                {
                  titleDictionaryKey: 'tmc-visit.widgets.registration-terminal.visitor-registration-type-selection.button.prepared',
                  titleIconCss: 'fa-thin fa-arrow-pointer',
                  descriptionDictionaryKey: 'tmc-visit.widgets.registration-terminal.visitor-registration-type-selection.description.prepared',
                  actionType: 'PROCESS_STEP',
                  processStepKey: 'visitor-registration-by-preparation'
                },
                {
                  titleDictionaryKey: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.button.secondary',
                  titleIconCss: 'fa-thin fa-plus',
                  descriptionDictionaryKey: 'tmc-yard.widgets.registration-terminal.transport-registration-type-selection.description.secondary',
                  actionType: 'PROCESS_STEP',
                  processStepKey: 'visitortype-selection'
                }
              ]
            }
          },
          {
            title: 'tmc-visit.widgets.registration-terminal.visitor-registration-preparation.title',
            key: 'visitor-registration-by-preparation',
            controller: 'visitor-registration-by-preparation-controller',
            contentIdentifier: 'WIDGET@visitorRegistrationPreparationWidget',
            dashboardConfiguration: {
              showCreateNewRegistrationButton: false,
              nextProcessStep: 'visitor-registration-masterdata',
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-role-selection.title',
            key: 'visitortype-selection',
            controller: 'visitor-visitortype-selection-controller',
            contentIdentifier: 'dashboard-process-selection',
            dashboardConfiguration: {
              roleDefaultProcessStep: {
                default: 'visitor-registration-masterdata'
              }
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-registration-masterdata.title',
            key: 'visitor-registration-masterdata',
            controller: 'visitor-registration-masterdata-controller',
            contentIdentifier: 'dashboard-visitor-registration-masterdata'
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-instructions.title',
            key: 'instruction-test',
            controller: 'instruction-test-controller',
            contentIdentifier: 'WIDGET@instructionTestWidget',
            dashboardConfiguration: {
              instructionConfigurationUrls: ['/assets/customer/fiege/instruction.json'],
              nextProcessStep: 'visitor-registration-send-data-to-backend',
              maxAllowedFailures: 0,
              testFailedTarget: 'instructions-failed'
            }
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-instructions.title',
            key: 'instructions-failed',
            controller: 'instruction-test-failed-controller',
            contentIdentifier: 'WIDGET@textWidget',
            dashboardConfiguration: {
              contentFile: '/assets/customer/fiege/instruction-failed.json',
              nextProcessStep: 'visitor-registration-masterdata'
            }
          },
          {
            title: null,
            key: 'visitor-registration-send-data-to-backend',
            controller: 'visitor-registration-send-data-to-backend-controller',
            contentIdentifier: null
          },
          {
            title: 'tmc-yard.widgets.registration-terminal.visitor-registration-summary.title',
            key: 'visitor-registration-summary',
            controller: 'visitor-registration-summary-controller',
            contentIdentifier: 'dashboard-visitor-registration-summary'
          }
          
        ]
      }
    }
  ]
};
